<div class="container">
  <mat-card>
    <form [formGroup]="centerEditMeetingScheduleForm">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Existing Meeting Date' | translate }}</mat-label>
            <mat-select formControlName="presentMeetingDate">
              @for (date of nextMeetingDates; track date) {
                <mat-option [value]="date">
                  {{ date | dateFormat }}
                </mat-option>
              }
            </mat-select>
            @if (centerEditMeetingScheduleForm.controls.presentMeetingDate.hasError('repeatsOnDay')) {
              <mat-error>
                {{ 'labels.inputs.Existing Meeting Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field (click)="newMeetingDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Revised Meeting Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="newMeetingDatePicker"
              required
              formControlName="newMeetingDate"
            />
            <mat-datepicker-toggle matSuffix [for]="newMeetingDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #newMeetingDatePicker></mat-datepicker>
            @if (centerEditMeetingScheduleForm.controls.newMeetingDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Revised Meeting Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!centerEditMeetingScheduleForm.valid" (click)="submit()">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
